import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { msConfig } from './ms-config';
import {  map } from "rxjs/operators";
import { ServiceRespone } from '../model/serviceResponse';
import { AppConstants } from 'src/environments/constants';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UtentiService {

  constructor(
    private http: HttpClient
  ) { }

  public getUtenteLoggato(): Observable<ServiceRespone>{
    let url = msConfig['ms-utenti'] + AppConstants.PATH_UTENTE;
    return this.http
    .get(url)
    .pipe(
      map((resp: ServiceRespone)=>{
        let okResp = new ServiceRespone;
        okResp.errorMex = resp["errorMex"];
        okResp.respObj = resp["respObj"];
        return okResp;
      })
    ) 
   
  }
  
}
